(function () {
  if (!('IntersectionObserver' in window)) return;

  var GROUPS = [
    ['.lsw__head', 0],
    ['.lsw__card', 70],
    ['.lsw__footer', 0],
    ['.lsp__head', 0],
    ['.lsp__proj .lsp__media', 0],
    ['.lsp__proj .lsp__body', 120],
    ['.lspf__copy', 0],
    ['.lspf__card', 140],
    ['.psteps__title', 0],
    ['.psteps__sub', 60],
    ['.psteps__item', 80],
    ['.psteps__cta', 0],
    ['.lsrl__head', 0],
    ['.lsrl__group', 70],

    // service detail
    ['.lssd__head', 0],
    ['.lssd__visit', 0],
    ['.lssd__steps li', 90],
    ['.lssd__hl', 120],
    ['.lssd__scope-title', 0],
    ['.lssd__item', 60],

    // checklist
    ['.lschk__head', 0],
    ['.lschk__group', 70],

    // video band
    ['.lsvb__head', 0],
    ['.lsvb__item', 130],

    // estimator
    ['.lsest__head', 0],
    ['.lsest__anchor', 0],
    ['.lsest__questions', 0],
    ['.lsest__result', 150],

    // plans, when it is not being used as the hero (the hero intro is
    // pure CSS, so it must not be reveal-gated as well)
    ['.lspl:not(.lspl--hero) .lspl__head', 0],
    ['.lspl:not(.lspl--hero) .lspl__grid .lspl__card', 90],
    ['.lspl:not(.lspl--hero) .lspl__panel', 0],

    // reviews and services: the block, not the slides, so the sliders
    // keep their own transforms
    ['.rev-header', 0],
    ['.service-card', 60],
    ['.services-footer', 0],

    // read-more copy
    ['.lsseo__title', 0],
    ['.lsseo__wrap', 60],

    // FAQ and the contact card
    ['.faq-accordion-custom .heading', 0],
    ['.faq-accordion-custom .accordion-item', 55],
    ['.faq-accordion-custom .btn-box', 0],
    ['.cc-contact-card', 0]
  ];

  var observer = null;

  function reveal(el) {
    el.classList.add('is-in');
    if (observer) observer.unobserve(el);
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 0) * 0.92 && r.bottom > 0;
  }

  function sweep() {
    document.querySelectorAll('[data-cine]:not(.is-in), [data-cine-zoom]:not(.is-in)').forEach(function (el) {
      if (inView(el)) reveal(el);
    });
  }

  function start() {
    // Nothing is hidden until this class lands, so a failure here is harmless.
    document.documentElement.classList.add('mp-cine');

    GROUPS.forEach(function (pair) {
      document.querySelectorAll(pair[0]).forEach(function (el, i) {
        el.setAttribute('data-cine', '');
        if (pair[1]) el.style.setProperty('--cine-delay', (i % 8) * pair[1] + 'ms');
      });
    });

    document.querySelectorAll('.lsp__stage, .lsw__card-media').forEach(function (el) {
      el.setAttribute('data-cine-zoom', '');
    });

    var targets = document.querySelectorAll('[data-cine], [data-cine-zoom]');
    if (!targets.length) return;

    try {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px -60px 0px', threshold: 0.1 });
      targets.forEach(function (el) { observer.observe(el); });
    } catch (e) {
      observer = null;
    }

    // Belt and braces: a scroll pass in case the observer never fires,
    // and a final sweep so nothing can be left invisible.
    sweep();
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
    window.addEventListener('load', sweep);
    // A tab opened in the background is throttled: the observer does not
    // deliver callbacks while the document is hidden, so catch up the
    // moment it is actually looked at.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sweep();
    });
    setTimeout(sweep, 600);
    setTimeout(function () {
      document.querySelectorAll('[data-cine], [data-cine-zoom]').forEach(function (el) {
        if (!el.classList.contains('is-in') && inView(el)) reveal(el);
      });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
